/**
 * This might look like duplicating what's already in the app, but it is intentional to keep everything in sync.
 * Also some en-us strings still needs to manage plurals and other contextual things.
 */
export default {
    translation: {
        "Welcome to React": "Welcome to React and react-i18next",
        "Decoding": "Decoding",
        "Phonological Awareness": "Phonological Awareness",
        "High Frequency Words": "High Frequency Words",
        "Background Knowledge": "Background Knowledge",
        "Structure and Reasoning": "Structure and Reasoning",
        "Vocabulary": "Vocabulary",
        "On Track": "On Track",
        "Catch Up": "Catch Up",
        "Ahead": "Ahead",
    },
    arm_floor:{
        "arm_floor_tooltip_content": "Based on National Norms, {{name}}'s ARM Score indicates they should be considered two or more grade levels behind.",
    },
    teacher_parent_report: {
        "a 0 grade": "a kindergarten",
        "a 1 grade": "a first grade",
        "a 2 grade": "a second grade",
        "a 3 grade": "a third grade",
        "a 4 grade": "a fourth grade",
        "a 5 grade": "a fifth grade",
        "a 6 grade": "a sixth grade",
        "a 7 grade": "a seventh grade",
        "a 8 grade": "an eighth grade",
        "a 0 grader": "a kindergartener",
        "a 1 grader": "a first grader",
        "a 2 grader": "a second grader",
        "a 3 grader": "a third grader",
        "a 4 grader": "a fourth grader",
        "a 5 grader": "a fifth grader",
        "a 6 grader": "a sixth grader",
        "a 7 grader": "a seventh grader",
        "a 8 grader": "an eighth grader",
        "0 month": "beginning",
        "1 month": "first month",
        "2 month": "second month",
        "3 month": "third month",
        "4 month": "fourth month",
        "5 month": "fifth month",
        "6 month": "sixth month",
        "7 month": "seventh month",
        "8 month": "eight month",
        "9 month": "ninth month",
        "10 month": "tenth month",
        "the student": "the student",
        "the student_plural": "the students",
        "Oral Reading Fluency Progress": "Oral Reading Fluency Progress",
        "Tips For Helping {{name}} Right Now": "Tips For Helping {{name}} Right Now",
        "Understanding {{name}}'s Scores": "Understanding {{name}}'s Scores",
        "parent_orf_score_tooltip": "Words Correct Per Minute (WCPM) is the standard measure of Oral Reading Fluency. Estimated Vocabulary size is a good indication of a student's level of comprehension and world knowledge. In both cases, the larger the number the better.", 
        "Parent Report for {{name}}": "Parent Report for {{name}}",
        "parent_arm_score_tooltip": "Your child's ARM score relates to their level of reading as it pertains to an age level measurement. Consider it as close to the age at which they are reading independently. An ARM score starting with 5 indicates a reading score of a typical 5 year old (which is in the kindergarten band.) Estimated Vocabulary size is a good indication of a student's level of comprehension and world knowledge. In both cases, the larger the number the better.",
        "student_overall_arm_description": "{{name}}’s overall reading mastery score is a measure of fluency. It shows the grade level at which {{name}} is reading independently. A score of {{score}} is {{pacing}}.",
        "student_overall_wcpm_description": "Words correct per minute (WCPM) is a measure of reading fluency. A WCPM of {{score}} is {{pacing}}.",
        "BELOW_GRADE_LEVEL": "Catch Up",
        "AT_GRADE_LEVEL": "On Track",
        "AHEAD_OF_GRADE_LEVEL": "Ahead",
        "Decoding": "Decoding",
        "Phonological Awareness": "Phonological Awareness",
        "Sight Recognition": "High Frequency Words",
        "High Frequency Words": "High Frequency Words",
        "Background Knowledge": "Background Knowledge",
        "Structure & Reasoning": "Structure & Reasoning",
        "Vocabulary": "Vocabulary",
        "Decoding_description": "Decoding is matching letters to sounds. For example: knowing the “c” in cat makes a “k” sound.",
        "domain_descriptions": {
            "Decoding": "Decoding is matching letters to sounds.",
            "Phonological Awareness": "Phonological Awareness is knowing how words are made up of sounds.",
            "Sight Recognition": "High frequency words are words that are very common. Readers will learn to recognize these and read them without sounding them out.",
            "Background Knowledge": "Background knowledge is knowing about a topic generally in order to better understand a story about that topic.",
            "Structure & Reasoning": "Structures and reasoning refers to the analysis, evaluation and synthesis of the text.",
            "Vocabulary": "Vocabulary refers to knowledge of the meanings of individual words being read. It is important to a student’s ability to read and comprehend what is read.",
        },
        "{{name}}\'s Overall Reading Mastery": "{{name}}\'s Overall Reading Mastery",
        "Batch Print": "Batch Print",
        "Scored better than {{percentage}}% of students": "Scored better than {{percentage}}% of students",
        "The {{leftScore}} to the left of the decimal indicates {{studentName}} is reading at {{currentGradeString}} level. The .{{rightScore}} to the right of the decimal indicates {{studentName}} is {{rightScore}}% of the way to {{nextGradeString}} reading level.": "The {{leftScore}} to the left of the decimal indicates {{studentName}} is reading at {{currentGradeString}} level. The .{{rightScore}} to the right of the decimal indicates {{studentName}} is {{rightScore}}% of the way to {{nextGradeString}} reading level.",
        "{{name}}\'s Reading Subscores": "{{name}}\'s Reading Subscores",
        "parent_arm_score_info": "The Amira Reading Mastery (ARM) score shows the grade level at which {{studentName}} is reading independently.",
        "parent_arm_score_info_spanish": "Your child's ARM (Amira reading proficiency) score shows their reading level based on their age.",
        "left_score_description": "The {{leftScore}} to the left of the decimal represents {{currentGradeString}} reading level.",
        "left_score_description_spanish_arm": "The {{leftScore}} to the left of the decimal point indicates a reading score for a typical {{leftScore}}-year-old child.",
        "right_score_description": "The .{{rightScore}} to the right of the decimal indicates the {{rightScoreDescription}} of the school year.",
        "right_score_description_spanish_arm": "The {{rightScore}} to the right of the decimal point indicates the percentage of mastery for the year that {{studentName}} has achieved. For example, half a semester would be measured as .5.",
    },
    teacher_report_chart_progress: {
        "WCPM": "WCPM",
        "Student’s ability to read aloud with natural ease": "Student’s ability to read aloud with natural ease",
        "Lexile": "Lexile",
        "AREA": "AREA",
        "Amira Reading Estimated Age": "Amira Reading Estimated Age",
        "ESRI": "EHFWI",
        "Expected High Frequency Words Inventory": "Expected High Frequency Words Inventory",
        "PSF": "PSF",
        "Phoneme Segmentation Fluency": "Phoneme Segmentation Fluency",
        "EVS": "EVS",
        "Estimated words in vocabulary": "Estimated words in vocabulary",
        "ARM": "ARM",
        "Amira reading mastery": "Amira reading mastery",
        "Latest Score": "Latest Score",
        "Predicted Ability": "Predicted Ability",
        "Excellent": "Excellent",
        "Average": "Average",
        "Below Expectations": "Below Expectations",
        "Jan": "Jan", 
        "Feb": "Feb", 
        "Mar": "Mar", 
        "Apr": "Apr",
        "May": "May", 
        "Jun": "Jun", 
        "Jul": "Jul", 
        "Aug": "Aug", 
        "Sep": "Sep", 
        "Oct": "Oct", 
        "Nov": "Nov",
        "Dec": "Dec",
    },
    teacher_dyslexia_letter: {
        "Dear": "Dear",
        "Sincerely": "Sincerely",
        "parent_letter_p1": "Thank you for your continued partnership in providing the best education for {{name}}. Each year, all students in our community participate in a dyslexia screener provided by Amira. The screener is similar to a reading assessment with students completing a variety of literacy tasks. This screener provides notices of risk for dyslexia and is not a diagnosis. Approximately 1 in 5 people are diagnosed with dyslexia and early detection through screening is imperative for helping these and all students reach their reading potential. For more information about dyslexia, visit",
        "parent_letter_p2": "Your child completed the Amira dyslexia screener on {{date}}. The screening results are below. You should read these results like a gauge on the dashboard of a car. Just like a dashboard provides signals on different aspects of the car's status, this screener indicates which skills are strengths or areas for growth for your child. This information can be valuable for you, your child, and obviously for us as the school helping them attain their academic goals. Through the screener, we've learned about your child's abilities in different tasks including: letter naming, segmenting the sounds in words, and decoding through matching letters and sounds. All children have strength skills and areas for improvement.",
        "parent_letter_p3": "The results from the dyslexia screener indicates {{name}} has reading struggles or areas for improvement that are often associated with dyslexia. It is important to remember that this screener is a signal of dyslexia risk and not a formal diagnosis. Based on these results, {{name}} might be considered for additional assessment or support -- but for now, it's important than you review the results and consider reading a priority for your child.  About 1 in 5 students show signs of dyslexia risk, so it's important to be informed and active.",
        "parent_letter_p4": "If you'd like to better understand these results or your role in supporting your child, please contact me so we can find a time to do so.  As your child's teacher, I will continue to monitor your child's progress, update you on their skills, and provide tools to support reading growth.",
        "parent_letter_p5": "If you have any questions, I am here to partner and support you and your child.",
        "activity_log": "As a parent, you can support your child by working on the skills mentioned above and watching for additional communication from the school. I've also included an activity log below that you can use to track skills practice at home.",
        "Domain": "Domain",
        "PR": "PR",
        "Status": "Status",
        "Description": "Description",
        "Home Activity Log": "Home Activity Log",
        "Goal": "Goal",
        "Activity we tried": "Activity we tried",
        "how_it_went": "How it went (Circle a face)",
        "example_goal": "Example Goal: Learn letter sounds",
        "example_activity": "Example Activity: Look at a page in a familiar book with your child, ask them which letters they recognize and the sounds associated with those letters.",
    }
}